"use client";

import { useLayoutEffect, useState } from "react";

const HEADER_SLOT = "[data-global-slot=header][data-header-pin=fixed]";

/**
 * In-flow stand-in for a `position:fixed` public header slot so content is not
 * covered. Height tracks the slot (compact chrome, drawer, util strip).
 */
export function PublicHeaderPinSpacer() {
	const [height, setHeight] = useState(0);

	useLayoutEffect(() => {
		const header = document.querySelector(HEADER_SLOT);
		if (!(header instanceof HTMLElement)) {
			return;
		}
		const sync = () => {
			setHeight(header.offsetHeight);
		};
		sync();
		const observer = new ResizeObserver(sync);
		observer.observe(header);
		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div
			aria-hidden="true"
			data-header-pin-spacer=""
			style={{
				flexShrink: 0,
				height,
				pointerEvents: "none",
				width: "100%",
			}}
		/>
	);
}
